type BarRadius = [number, number, number, number];

const BAR_CORNER_RADIUS = 4;
const VERTICAL_BAR_RADIUS: BarRadius = [BAR_CORNER_RADIUS, BAR_CORNER_RADIUS, 0, 0];
const HORIZONTAL_BAR_RADIUS: BarRadius = [0, BAR_CORNER_RADIUS, BAR_CORNER_RADIUS, 0];

interface StackSegment {
  /** The data point of the bar, as Recharts passes it to a bar shape. */
  point: unknown;
  seriesCount: number;
  seriesIndex: number;
}

const valueOf = (point: unknown, seriesIndex: number) => {
  if (typeof point !== 'object' || point === null || !(`series${seriesIndex}` in point)) {
    return 0;
  }
  const value: unknown = Reflect.get(point, `series${seriesIndex}`);
  return typeof value === 'number' ? value : 0;
};

/**
 * Corner radius of a bar in the look of the charts on screen: only the data end is rounded, and
 * a stacked bar only at the outer end of its stack, in the direction of its value.
 */
export function getDocumentBarRadius(isHorizontal: boolean, segment?: StackSegment) {
  const radius = isHorizontal ? HORIZONTAL_BAR_RADIUS : VERTICAL_BAR_RADIUS;
  if (!segment) {
    return radius;
  }
  const value = valueOf(segment.point, segment.seriesIndex);
  const laterValues = Array.from(
    {length: segment.seriesCount - segment.seriesIndex - 1},
    (_, offset) => valueOf(segment.point, segment.seriesIndex + offset + 1)
  );
  const isOuterEnd =
    value > 0
      ? laterValues.every((laterValue) => laterValue <= 0)
      : value < 0 && laterValues.every((laterValue) => laterValue >= 0);
  return isOuterEnd ? radius : 0;
}
